import React, { useMemo } from 'react';
import MetricsCardWrap from '@sg/components/MetricsCardWrap';
import MetricsCardRank from '@/pages/dashboard/components/MetricsCardRank';
import Triangle from '@/pages/strategic/components/Triangle';
import RoundedTriangleImage from '@/pages/strategic/components/Triangle/RoundedTriangle';
import MetricsCardWithRank from './MetricsCardWithRank';
import { IMetricsCardWithRank } from './type';
import './index.scss';
import { useIntl } from 'umi';

const TRIANGLE_SIZE = 32;
const MetricsCardWithRankWrap = (props: IMetricsCardWithRank) => {
  const { formatMessage } = useIntl();
  const { titleEn, titleCn, subtitleEn, subtitleCn, icon, imgUrl, link, tipsEn, tipsCn, definition, source, updateTime, isIconTips, contentHeader, metricsChart, rankStyle, rankData, rankFormatRule, subFormatRule, style, className, overlayClassName, metricData, contentFooter, rankClassName } = props;

  const { totalMetrics, splitMetrics, hasEmptyTotalMetrics } = useMemo(() => {
    const totalMetrics: IMetricsCardWithRank[] = [];
    const splitMetrics: IMetricsCardWithRank[] = [];
    metricData?.forEach(item => {
      if (item.metricType === 'total') {
        totalMetrics.push(item);
      } else if (item.metricType === 'split') {
        splitMetrics.push(item);
      }
    });
    console.log('totalMetrics', totalMetrics, splitMetrics);

    // Check if all total metrics have no data
    const hasEmptyTotalMetrics = totalMetrics.length > 0 && totalMetrics.every(item => !parseInt(String(item.value)));

    return {
      totalMetrics,
      splitMetrics,
      hasEmptyTotalMetrics
    };
  }, [metricData]);

  // Check if rank data is empty
  const hasEmptyRankData = !rankData || rankData.length === 0 || !rankData.some(item => item.value);

  // Check if this is a unit_sales card (for determining which empty message to show)
  const isUnitSalesCard = totalMetrics.some(item => item.key === 'unit_sales');

  // When totals are empty and rank list is empty/invalid, show the centered empty
  // message block directly and skip the normal stack layout.
  const showCenteredEmptyMessage = hasEmptyTotalMetrics && hasEmptyRankData;
  const shouldHideRankSection = hasEmptyTotalMetrics || hasEmptyRankData;

  return (
    <div className='dbs-metrics-card-with-rank'>
      <MetricsCardWrap
        titleCn={titleCn}
        titleEn={titleEn}
        className={className}
        overlayClassName={overlayClassName}
        style={style}
        link={link}
        tipsEn={tipsEn}
        tipsCn={tipsCn}
        definition={definition}
        source={source}
        updateTime={updateTime}
        icon={icon}
        imgUrl={imgUrl}
        isIconTips={isIconTips}
        subtitleEn={subtitleEn}
        subtitleCn={subtitleCn}
        contentHeader={contentHeader}
        contentFooter={contentFooter}
      >
        {showCenteredEmptyMessage ? (
          <div className="dbd-metrics-card-with-rank__empty-message">
            {isUnitSalesCard
              ? formatMessage({ id: 'dbs_empty_text_unit_sales' })
              : formatMessage({ id: 'dbs_empty_text' })
            }
          </div>
        ) : (
          <div className={`dbd-metrics-card-with-rank__flex dbd-metrics-card-with-rank__stack`}>
            <div className='dbd-metrics-card-with-rank__top'>
              <div className='dbd-metrics-card-with-rank__top-left'>
                {
                  totalMetrics?.map(item => (
                    <MetricsCardWithRank data={item} key={item.titleEn} showTitle={false} metricKey={item.key} />
                  ))
                }
              </div>
              {!hasEmptyTotalMetrics && (
                <div className='dbd-metrics-card-with-rank__top-right'>
                  {metricsChart}
                </div>
              )}
             
            </div>
            {!shouldHideRankSection && (
              <div className='dbd-metrics-card-with-rank__bottom'>
                <MetricsCardRank
                  className={rankClassName}
                  style={rankStyle}
                  data={rankData}
                  formatRule={rankFormatRule}
                  subFormatRule={subFormatRule}
                />
              </div>
            )}
          </div>
        )}
        <div className='dbd-metrics-card-with-rank__child-metrics-card-wrap'>
          <RoundedTriangleImage
            size={64}
            position="top-center"
            style={{
              // 这里的20是padding
              top: '-45px',
            }}
          />
          {/* <Triangle
            color={'rgba(127, 111, 241, 0.1)'}
            size={TRIANGLE_SIZE}
            position={'top-center'}
            style={{
              // 这里的20是padding
              top: '-44px',
              left: `50%`,
            }}
          /> */}

          {
            splitMetrics?.map(item => (
              <MetricsCardWithRank data={item} key={item.titleEn} metricKey={item.key} />
            ))
          }
        </div>
      </MetricsCardWrap>
    </div>
  );
};

export default MetricsCardWithRankWrap;
